import React, { type SyntheticEvent, useEffect, type ReactNode } from 'react';
import Button from '@atlaskit/button';
import EmptyState from '@atlaskit/empty-state';
import { PROJECTS_PAGE_JWM_EMPTY_LIST } from '@atlassian/jira-business-sample-project/src/common/constants.tsx';
import { jwmSampleProjectUrlWithOriginSource } from '@atlassian/jira-business-sample-project/src/common/utils.tsx';
import { useCreateSampleProject } from '@atlassian/jira-business-sample-project/src/controllers/create-jwm-sample-project/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import {
	type UIAnalyticsEvent,
	fireUIAnalytics,
	ContextualAnalyticsData,
	FireScreenAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import {
	JWM_INTRO_ANIMATION_IMAGE_WIDTH,
	JWM_INTRO_ANIMATION_IMAGE_HEIGHT,
} from '../../constants.tsx';
import messages from '../../messages.tsx';

export const TryJWMSampleProjectView = ({ children }: { children: ReactNode }) => {
	const { formatMessage } = useIntl();
	const { createSampleProject, taskId } = useCreateSampleProject();

	const createSampleProjectClicked = (_event: SyntheticEvent, analyticsEvent: UIAnalyticsEvent) => {
		createSampleProject();
		fireUIAnalytics(analyticsEvent, 'jwmSampleProjectExperimentCreateProjectButton');
	};

	useEffect(() => {
		if (taskId) {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.open(
				jwmSampleProjectUrlWithOriginSource(taskId, PROJECTS_PAGE_JWM_EMPTY_LIST),
				'_self',
			);
		}
	}, [taskId]);

	return (
		<ContextualAnalyticsData sourceName="emptyProjectsListTryJWMSampleProject" sourceType={SCREEN}>
			<FireScreenAnalytics />
			<EmptyState
				renderImage={() => children}
				maxImageHeight={JWM_INTRO_ANIMATION_IMAGE_HEIGHT}
				maxImageWidth={JWM_INTRO_ANIMATION_IMAGE_WIDTH}
				imageHeight={JWM_INTRO_ANIMATION_IMAGE_HEIGHT}
				imageWidth={JWM_INTRO_ANIMATION_IMAGE_WIDTH}
				header={formatMessage(messages.jiraWorkManagementTrySampleProjectCtaHeading)}
				description={formatMessage(
					messages.jiraWorkManagementTrySampleProjectCtaDescriptionComplexspork,
				)}
				primaryAction={
					<Button appearance="primary" onClick={createSampleProjectClicked}>
						{formatMessage(messages.jiraWorkManagementTrySampleProjectCtaButton)}
					</Button>
				}
			/>
		</ContextualAnalyticsData>
	);
};
